export default function instagramPopup({main, elm, state, subscribe}) {
	const dialog = elm.closest('dialog');
	const slider = elm.querySelector('.swiper--insta');
	const sliderWrapper = slider.querySelector('.swiper-wrapper');
	const video = elm.querySelector('video');

	main(_ => {
		subscribe('instagram:open', open);
		dialog.addEventListener('close', stopVideo);
	});

	const open = function (item) {
		stopVideo();

		state.set(s => {
			s.id = item.id;
			s.thumbnail = item.thumbnail;
			s.media = item.media;
			s.type = item.type;
			s.children = item.children;
			s.link = item.link;
			s.caption = item.caption;
			s.timestamp = item.timestamp;
		});

		if (item.children.length > 0) {
			let slides = '';
			item.children.forEach(photo => {
				slides += `
			<div class="review-photo swiper-slide--insta">
				<img src="${photo}" class="review-photo__img" alt="">
		  	</div>
			`;
			});

			sliderWrapper.innerHTML = slides;
		}

		dialog.showModal();

		slider.swiper.update();

		if (item.type === 'video') {
			video.load();
		}
	}

	const stopVideo = function () {
		video.pause();
		video.currentTime = 0;
	}
};

export const model = {};
